export const MAX_BOARDS_CREATE = 70;
